import React from 'react';
import { DateFieldShow } from 'components/Fields';
import { ViewTitle } from '../../../components/AppBar/Titles';
import { Show, SimpleShowLayout, TextField, RichTextField, 
				ReferenceArrayField, SingleFieldList, ChipField } from 'react-admin';

export const StoriesShow = (props) => (
	<Show title={<ViewTitle source='name' />} {...props}>
		<SimpleShowLayout>
			<TextField source='id' label='ID' />
			<TextField source='name' label='Name' />
			<RichTextField source='description' label='Description' />
			<ReferenceArrayField source='events_ids' reference='events' label='Events'>
				<SingleFieldList>
					<ChipField source='title' />
				</SingleFieldList>
			</ReferenceArrayField>
			<DateFieldShow source='created_at' label='Created At' />
			<DateFieldShow source='updated_at' label='Updated At' />
		</SimpleShowLayout>
	</Show>
);